import React, { useState } from "react";
import * as language from "../../utils/language.js";

const Label = (props) => {
  //========================================================================
  // Zustandsvariablen definieren

  //========================================================================
  // Logik

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        visibility: props.props.visibility,
      }}
    >
      <div
        style={{
          overflow: "hidden",
          whiteSpace: "pre-wrap",
          boxSizing: "border-box",
          textAlign: props.style?.justifyContent
        }}
      >
        {language.displayText(props.props.text)}
      </div>
    </div>
  );
};

export default Label;
